var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bafca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-89 -7225)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 2507)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 4718)",
    fill: "none",
    stroke: "#dae028",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100 7236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.46,80.1H254.54a5.019,5.019,0,0,1-5.04-5.04V57.14a5.019,5.019,0,0,1,5.04-5.04h17.92a5.019,5.019,0,0,1,5.04,5.04V75.06A5.019,5.019,0,0,1,272.46,80.1ZM263.5,61.62a4.48,4.48,0,1,0,4.48,4.48A4.493,4.493,0,0,0,263.5,61.62Zm10.64-6.16h-4.48v4.48h4.48Zm.56,7.84h-3.864a7.761,7.761,0,0,1,.5,2.8,7.84,7.84,0,1,1-15.68,0,7.761,7.761,0,0,1,.5-2.8H252.3V73.38a3.9,3.9,0,0,0,3.92,3.92h14.56a3.9,3.9,0,0,0,3.92-3.92Z",
    transform: "translate(-249.5 -52.1)",
    fill: "url(#a)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram2);
export default __webpack_public_path__ + "static/media/Instagram_2.9c71c34db24a48a3c8a10e7bacfb2bd7.svg";
export { ForwardRef as ReactComponent };